import styled from "styled-components";

const RowStyle = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  color: #555555;
  padding: 4px;
`;

const LabelContainerStyle = styled.div`
  flex: 1;
  margin-right: 20px;
  // min-width: 150px;
  // max-width: 150px;
  font-weight: 500;
  color: black;
  font-size: 13px;
`;

const ValueContainerStyle = styled.div`
  flex: 6;
  display: block;
  justify-content: flex-start;
  color: #1a1818ff;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

const SC = {
  RowStyle,
  LabelContainerStyle,
  ValueContainerStyle,
};

export default SC;
